export const decimalVersionHeader = {
  'X-SHIPWELL-VERSION': '2024-06-11'
};
